import React, { PureComponent } from "react";
import _ from "lodash";
import { parterLogo } from "../data/Common/parterLogo";

class GroupPartnerLogo extends PureComponent {
  render() {
    const filterRow = (row) =>
      _.filter(parterLogo, (i) => _.get(i, "row", 1) === row);

    return (
      <div className="container-group-partner-logo">
        <div className="group-partner-logo">
          <div className="group-logo-row-1">
            {_.map(filterRow(1), (item, key) => {
              if (item.showLogo === true) {
                return (
                  <a href={item.link} key={key}>
                    <img src={item.logoImg} alt="" />
                  </a>
                );
              }
            })}
          </div>
          <div className="group-logo-row-2">
            {_.map(filterRow(2), (item, key) => {
              if (item.showLogo === true) {
                if (_.get(item, "class") === "angsana") {
                  return (
                    <a href={item.link} key={key}>
                      <div class="icon-holder">
                        <img class={item.class} alt="" src={item.logoImg} />
                      </div>
                    </a>
                  );
                }
                return (
                  <a href={item.link} key={key}>
                    <img src={item.logoImg} alt="" />
                  </a>
                );
              }
            })}
          </div>
          {/* {_.map(parterLogo, (item, key) => {
            const row = _.get(item, "row", 1);
            if (item.showLogo === true) {
              // return (
              //   <a href={item.link} key={key}>
              //     <img src={item.logoImg} alt="" />
              //   </a>
              // );
            }
          })} */}
        </div>
      </div>
    );
  }
}

export default GroupPartnerLogo;



// WEBPACK FOOTER //
// ./src/components/GroupPartnerLogo.js